import * as BarrierActions from '../actions/barriers.actions';
import { PossibleBarrierModel } from '../../models';

export type Action = BarrierActions.All;

export interface BarriersState {
    barriers: PossibleBarrierModel[];
    loading: boolean;
    error: string;
}

const defaultState: BarriersState = {
    barriers: [],
    loading: false,
    error: null
};

export const barriersReducer = (state: BarriersState = defaultState, action: Action): BarriersState => {
    switch (action.type) {

        case BarrierActions.GET_BARRIERS: {
            return {
                barriers: [],
                loading: true,
                error: null
            };
        }

        case BarrierActions.GET_BARRIERS_SUCCESS: {
            return {
                barriers: action.barriers,
                loading: false,
                error: null
            };
        }

        case BarrierActions.GET_BARRIERS_FAILURE: {
            return {
                barriers: [],
                loading: false,
                error: action.error
            };
        }

        case BarrierActions.ADD_BARRIER: {
            const newBarriers = state.barriers.slice(0);
            newBarriers.push({
                lat: action.lat,
                lng: action.lng
            });
            return {
                barriers: newBarriers,
                loading: false,
                error: null
            };
        }

        default: {
            return state;
        }
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/reducers/possible-barriers.reducer.ts